import getAxios from "../helpers/axiosInterceptor";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const downloadFileThunk = createAsyncThunk(
  "file/download",
  async (url, thunkApi) => {
    try {
  

      const res = await getAxios().get(url);
    
      
  

      const presignedUrl = res?.data?.url ?? res?.data; 
      
     
      // Step 2 — presigned url is self sufficient, download directly
      const link = document.createElement('a');
      link.href = presignedUrl;
      link.click();
      link.remove();

      return { success: true }; // Makes .unwrap() meaningful

    } catch (error) {
      return thunkApi.rejectWithValue(error?.response?.data || 'Download failed');
    }
  }
);